import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserStatus } from '../../models/user-status';
import { GuardDataKeys } from '../constants/guard-constants';
import { UserStateService } from '../../../modules/user/shared/services/user-state/user-state.service';

@Injectable({
    providedIn: 'root',
})
export class AuthenticatedUserStatusGuard {
    constructor(private readonly userStateService: UserStateService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const user = this.userStateService.user$.getValue();
        if (!user) {
            console.error(
                'User not authenticated, the general auth guard may not have been used before this guard.',
            );
            return of(false);
        }

        const permittedUserStatuses =
            route.data[GuardDataKeys.PERMITTED_USER_STATUSES];

        return of(
            permittedUserStatuses.includes(
                UserStatus.getAuthenticatedUserStatus(user),
            ),
        );
    }
}
